export const SliderControlsWrapper =
  'lg:hidden flex h-[60px] m-auto max-w-[1680px] w-full items-center justify-center select-none'

export const SliderCarouselWrapper =
  'flex flex-col py-10 md:py-24 w-full relative overflow-hidden lg:overflow-auto'

export const SliderCarouselItemsWrapper =
  'flex m-auto max-w-[1680px] w-full items-start justify-between relative transition-transform lg:overflow-hidden min-h-[540px]'

export const SliderCarouselControlsWrapper =
  'lg:hidden flex m-auto max-w-[1680px] h-[48px] w-full items-center justify-between select-none absolute left-0 right-0 top-[452px] md:top-[648px]'

export const SliderTextContentWrapper =
  'lg:hidden flex flex-col justify-center shrink-0 grow-0 w-full text-white h-40 lg:h-[300px] pl-4 xl:pl-[80px]'

export const SliderArrowIconColor = 'bg-white/50 focus:shadow-none'

export const SliderCarouselBackgroundStyle = {
  dark: 'bg-black',
  light: 'bg-white'
}

export const SliderCarouselForegroundStyle = {
  light: 'bg-black',
  dark: 'bg-white'
}

export const SliderCarouselIndicatorWrapper =
  'relative flex h-full w-fit items-center justify-between focus:outline-none active:outline-none'

export const SliderCarouselIndicatorItemWrapper = 'm-auto w-12 h-[2px]'

export const SliderCarouselIndicatorItem =
  'my-auto mx-1 flex h-full cursor-pointer focus:outline-none active:outline-none'
